/**
 * Parse all URL query parameters into a plain object.
 * Values are URL-decoded strings. Duplicate keys use the last value.
 * Returns an empty object if no params exist.
 */
export const parseUrlParams = () => {
  const params = new URLSearchParams(window.location.search);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
};
